// extracted by mini-css-extract-plugin
export var cardWrapper = "_4l-0";